import { getCacheLocale, i18nClient } from '@sailor/i18n-web'
import qs from 'qs'
import {
  testEnvHost, AWPENVMAP, HOSTENVMAP,
  testEnvSSOClientId, productEnvSSOClientId,
} from '../constants'
import { commonRequest } from '../api'
import { isRtlLocale } from '@sailor/i18n-rtl'

// 数据格式：{ locale: 'en', label: 'English' },
let localeInfo = {}

// 当前是否RTL环境
const isRTL = () => isRtlLocale(getCacheLocale())

// 判断是否为本地环境
const isLocal = ihost => {
  if (!process.env.AWP_DEPLOY_ENV) return true
  if (ihost) {
    return /^localhost/.test(ihost)
  }
  const { host } = window.top ? window.top.location : window.location
  return /^localhost/.test(host)
}

const isTest = host => new RegExp(`${testEnvHost}$`).test(host)

const isProd = (includeSt = true, byHost = false) => {
  let prod, st
  if (byHost) {
    const env =  getEnv()
    prod = env === 'prod'
    st = env === 'st'
  } else {
    const AWP_DEPLOY_ENV = process.env.AWP_DEPLOY_ENV
    prod = AWP_DEPLOY_ENV === 'production'
    st = AWP_DEPLOY_ENV === 'staging'
  }
  return includeSt ? (prod || st) : prod
}

// return test st prod
const getEnv = (processEnv = {}) => {
  try {
    if (process.env.AWP_DEPLOY_ENV || processEnv.AWP_DEPLOY_ENV) {
      const AWP_DEPLOY_ENV = process.env.AWP_DEPLOY_ENV || processEnv.AWP_DEPLOY_ENV
      return AWPENVMAP[AWP_DEPLOY_ENV] || 'prod'
    }
    return HOSTENVMAP[getHost(true)] || 'prod'
  } catch (e) {
    console.log(e)
    return HOSTENVMAP[getHost(true)] || 'prod'
  }
}

const safeParse = (str, defaultVal = {}) => {
  try {
    return JSON.parse(str)
  } catch (e) {
    console.log(e)
    return defaultVal
  }
}

// 获取当前域名
// 注意：local会返回test的host
const getHost = (hostOnly = false) => {
  const { host, protocol } = window.top ? window.top.location : window.location
  const currentHost = isLocal(host) ? testEnvHost : host
  return hostOnly ? currentHost : `${protocol}//${currentHost}`
}

// sso登录地址
const getSSOLoginUrl = () => {
  const { origin, href, host } = window.top ? window.top.location : window.location
  // 登录域名
  const isRunDev = isLocal(host)
  const isTestEnv = isTest(host)
  const sso_host =
    isTestEnv || isRunDev
      ? 'http://ssosv.it.test.sankuai.com/sson'
      : 'https://ssosv.sankuai.com/sson'
  const loginOrigin = `${sso_host}/login`
  const clientId = isTestEnv || isRunDev ? testEnvSSOClientId : productEnvSSOClientId
  const currentPath = href.replace(new RegExp(`^${origin}`), '')
  return `${loginOrigin}?client_id=${clientId}&redirect_uri=${encodeURIComponent(
    `${origin}/api/partner/sso/callback?original-url=${encodeURIComponent(currentPath)}`,
  )}`
}

const toSSOLogin = () => {
  sessionStorage.removeItem('LOGIN_PARTNERID')
  sessionStorage.removeItem('cityId')
  window.top ? (window.top.location.href = getSSOLoginUrl()) : (location.href = getSSOLoginUrl()) // 默认登出后再登录是重定向到应用首页
}

// https://km.sankuai.com/collabpage/1463829017
const logout = (url) => {
  commonRequest.get('/api/partner/sso/logout').finally(() => {
    sessionStorage.removeItem('LOGIN_PARTNERID')
    sessionStorage.removeItem('cityId')
    window.top ? (window.top.location.href = getSSOLoginUrl()) : (location.href = getSSOLoginUrl())
  })
}

const getQueryValues = (key = '') => {
  const search = qs.parse(location.search, { ignoreQueryPrefix: true })
  if (key) return search[key]
  return search
}

const setLocaleInfo = locale => {
  localeInfo = { locale: getCacheLocale(), ...localeInfo, ...locale }
}

const getLocaleInfo = () => ({ locale: getCacheLocale(), ...localeInfo })

const setCurrentUserInfoToSessionStorage = info => {
  const oldUserInfo = getCurrentUserInfoFromSessionStorage()
  const newUserInfo = { ...oldUserInfo, ...(info || {}) }
  sessionStorage.setItem('PARTNER_USER_INFO', JSON.stringify(newUserInfo))
}
const getCurrentUserInfoFromSessionStorage = () => {
  const infoJson = sessionStorage.getItem('PARTNER_USER_INFO') || '{}'
  return safeParse(infoJson)
}


const getI18nParams = () => {
  let { region } = getCurrentUserInfoFromSessionStorage() || {}
  region = region || 'SA'
  return {
    locale: getLocaleInfo().locale || 'en',
    region,
  }
}
// 权限相关
// 按钮功能权限判断，在uac配置对应接口url作为key，或纯文本key，并关联权限
function hasPermission (key) {
  if (isLocal()) return true
  return window.top._hasPermission && window.top._hasPermission(key)
}

function getQuery () {
  const [host, search] = location.href.split('?')
  if (!search) return {}
  return search.split('&').reduce((dist, item) => {
    const [key, value] = item.split('=')
    return { ...dist, [key]: value }
  }, {})
}

// 获取语言
const getLanguage = () => (i18nClient.isInitialized ? i18nClient.getCurrentLocale() : getCacheLocale()) || 'en'

export {
  hasPermission,
  isLocal,
  isTest,
  isProd,
  getEnv,
  logout,
  getHost,
  getSSOLoginUrl,
  setLocaleInfo,
  getLocaleInfo,
  getI18nParams,
  getQueryValues,
  getQuery,
  safeParse,
  toSSOLogin,
  isRTL,
  setCurrentUserInfoToSessionStorage,
  getCurrentUserInfoFromSessionStorage,
  getLanguage,
}
